import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { SessionsService } from 'projects/app-core/src/app/session/service/sessions.service';
import { SessionFeedbackSelectorComponent } from './session-feedback-selector.component';
import { TherapyPlansSubscriptionSessionDetails } from '../../models/therapyPlansSubcriptionGridResponse';

export interface TherapistOption {
  label: string;
  value: string;
}

/** "Send feedbacks to therapist" from a plan or pack subscription row. */
@Component({
  selector: 'app-send-feedback-document-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzModalModule,
    NzSelectModule,
    SessionFeedbackSelectorComponent,
  ],
  templateUrl: './send-feedback-document-modal.component.html',
})
export class SendFeedbackDocumentModalComponent {
  @Input() visible = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Input() sessions: TherapyPlansSubscriptionSessionDetails[] = [];
  @Input() therapistOptions: TherapistOption[] = [];
  @Input() set defaultTherapistId(id: string | undefined) {
    this.selectedTherapistId = id || '';
  }

  selectedTherapistId = '';
  selectedSessionIds: string[] = [];
  sending = false;

  constructor(
    private sessionsService: SessionsService,
    private toastService: ToastService,
  ) {}

  close() {
    this.selectedSessionIds = [];
    this.visible = false;
    this.visibleChange.emit(false);
  }

  send() {
    this.sending = true;
    this.sessionsService
      .sendFeedbackDocument({
        sessionIds: this.selectedSessionIds,
        therapistId: this.selectedTherapistId,
      })
      .subscribe({
        next: () => {
          this.sending = false;
          this.toastService.showSuccess(
            `Feedback for ${this.selectedSessionIds.length} session(s) sent to the therapist`,
          );
          this.close();
        },
        error: (err) => {
          const errorBody = err.error as IAnyoError;
          this.toastService.showAnyoErrorToast(errorBody?.description);
          this.sending = false;
        },
      });
  }
}
